module.exports = __webpack_public_path__ + "img/logo_ssfire@3x.820dd52d.png";